// extracted by mini-css-extract-plugin
export default {"walletCard":"ConnectedWalletView_walletCard__CBpW8","walletHeader":"ConnectedWalletView_walletHeader__eJQgz"};